<template>
  <div class="md-group info-icon">
    &nbsp;<span @click="notify()"><svg-icon type="mdi" :path="icons.info"></svg-icon></span>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiInformationSlabCircle } from '@mdi/js'
export default {
  name: "info-icon",
  props: ['message'],
  methods: {
    notify() {
      // Si una notificación sigue visible en pantalla, no permitir otra
      const exists = document.querySelector('.alert');
      if (exists) return;

      this.$notifications?.closeAll?.();

      const timeout = 4000;
      this.isShowing = true;

      this.$notify({
        message: this.message,
        icon: 'add_alert',
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: 'default',
        timeout
      });

      // Esperar a que desaparezca visualmente el elemento .alert
      const checker = setInterval(() => {
        const stillExists = document.querySelector('.alert');
        if (!stillExists) {
          clearInterval(checker);
          this.isShowing = false;
        }
      }, 100);
    },
  },
  components: {
    SvgIcon
  },
  data(){
    return{
      icons: {
        info: mdiInformationSlabCircle,
      },
      isShowing: false
    }
  }
}
</script>

<style scoped>
  .info-icon{
    margin-top: 6px;
    cursor: pointer;
  }
  /* span {
    background-color: ;
  } */
</style>
